import { motion } from "framer-motion";

export default function ConceptSection() {
  return (
    <section id="concept" className="relative w-full py-20 md:py-32 bg-warm-950">
      <div className="max-w-[1000px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          {/* Left — Text */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="w-full lg:w-1/2"
          >
            <span className="inline-block px-4 py-1.5 text-xs md:text-sm font-sans font-medium tracking-super-wide text-warm-400 bg-warm-800 border border-warm-700 rounded-full mb-6 md:mb-8">
              CONCEPT
            </span>

            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-warm-50 leading-tight">
              BAR bebéとは
            </h2>

            <div className="mt-6 md:mt-8 space-y-4 md:space-y-5">
              <p className="text-sm md:text-base font-sans font-normal text-warm-300 leading-relaxed">
                <span className="text-amber-500 font-medium">bebé</span>
                はスペイン語で「赤ちゃん」という意味です。
              </p>
              <p className="text-sm md:text-base font-sans font-normal text-warm-400 leading-relaxed">
                「みんなで育てていこう」「ありのままの姿でいよう」——
                そんな想いで名付けました。
              </p>
              <p className="text-sm md:text-base font-sans font-normal text-warm-400 leading-relaxed">
                BAR初心者の方が気軽に扉を開けられる場所を目指しています。
                初めての方も、常連の方も、みんなが居心地よく過ごせる空間を作っていきます。
              </p>
            </div>
          </motion.div>

          {/* Right — Bar Image */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="w-full lg:w-1/2"
          >
            <img
              src="/concept-bar.jpg"
              alt="BAR bebé バーカウンター"
              className="w-full h-72 md:h-96 object-cover rounded-2xl shadow-xl"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
